import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ScheduledRide, StawavScheduledRideInput } from '@/models/scheduledRide';

export const replaceStaWavScheduledRide = async ({
  scheduledRideId,
  data,
}: {
  scheduledRideId: number;
  data: StawavScheduledRideInput;
}): Promise<ScheduledRide> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation ReplaceStaWavScheduledRide($scheduledRideId: Float!, $data: StawavScheduledRideInputType!) {
        replaceStaWavScheduledRide(scheduledRideId: $scheduledRideId, data: $data) {
          id
        }
      }
    `),
    variables: {
      scheduledRideId,
      data,
    },
  });

  return response.data?.replaceStaWavScheduledRide!;
};
